import angular from 'angular';

let CampaignDetailController = function ($filter, $mdDialog, $scope, $state, $timeout, Campaign, News, Toast) {
  let $ctrl = this;

  $ctrl.id = $state.params.id;

  angular.extend($ctrl, {
    clearForm,
    handleSave,
    handleDelete,
    onChangeEndDate,
    onChangeStartDate,
    querySearch,
    selectedNewsItemChange
  });

  activate();

  function activate() {
    clearForm();

    angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
    
    let id = $ctrl.id;

    loadDomainResources()
      .then(result => {
        $ctrl.newsItems = result[0];

        loadResource($ctrl.id);
      })
      .catch(err => {
        console.log('err:' ,  err);
        $ctrl.uiState = 'ERROR';
      });
  }

  function clearForm(form) {
    $ctrl.campaign = {
      start_date: moment(),
      end_date: moment()
    };

    $ctrl.myImage = '';
    $ctrl.myCroppedImage = '';
    $ctrl.fileName = undefined;

    if (form) {
      form.$setPristine(); 
      form.$setUntouched();
    }
  }
  $ctrl.minDate = new Date();

  function handleDelete(campaign, event) {
    let confirm = $mdDialog.confirm()
      .textContent($filter('translate')('campaign-detail-delete-confirm-text'))
      .ariaLabel($filter('translate')('campaign-detail-delete-confirm-text'))
      .targetEvent(event)
      .ok($filter('translate')('common-yes'))
      .cancel($filter('translate')('common-cancel'));

    $mdDialog.show(confirm)
      .then(() => {
        $ctrl.deleting = true;
        Campaign
          .destroy(campaign)
          .then(response => {
            Toast.success($filter('translate')('campaign-detail-delete-success'));
            $ctrl.deleting = false;
            $state.go('campaign.list')
          })
          .catch(err => {
            Toast.error($filter('translate')('common-server-error'));
            console.log('err:' ,  err);
            $ctrl.deleting = false;
          });
      })
      .catch(() => {
      });
  }

  function handleSave(form, campaign) {
    campaign.image_base64 = $ctrl.myCroppedImage;

    if (!form.$valid || ((!campaign.image_base64 && !campaign.image_uri))) {
      Toast.error($filter('translate')('common-form-incomplete'));
      return;
    }

    $ctrl.saving = true;

    Campaign
      .save(campaign)
      .then(response => {
        Toast.success($filter('translate')('campaign-detail-save-success'));
        $state.go('campaign.list');
      })
      .catch(err => {
        let defaultErrMsg = 'common-server-error';
        let fourONineMsg = 'campaign-detail-409-error';
        let message = err.status == 409 ? fourONineMsg : defaultErrMsg;
        Toast.error($filter('translate')(message));
        console.log('err:' ,  err);
        $ctrl.saving = false;
      });
  }

  function onChangeStartDate(form) {
    $timeout(() => {
      $ctrl.campaign.end_date = null
      form.end_date.$validate();
    }, 100);
  }

  function onChangeEndDate(form) {
    $timeout(() => {
      form.start_date.$validate();
    }, 100);
  }

  function querySearch(searchText) {
    searchText = searchText.toLowerCase();

    let results = _.filter($ctrl.newsItems, newsItem => {
      return newsItem.title.toLowerCase().indexOf(searchText) > -1;
    });

    return results;
  }

  function selectedNewsItemChange(newsItem) {
    $ctrl.campaign.news_item_id = newsItem ? newsItem.id : null;
  }

  // Local functions

  function handleFileSelect(event) {
    let file = event.currentTarget.files[0];

    if (!file) {
      console.log('no file added!');
      return;
    }

    let reader = new FileReader();
    reader.onload = function (event) {
      $ctrl.myImage = event.target.result;
      $scope.$apply();
      $ctrl.fileName = file.name;
      showCropDialog(event);
    };

    reader.readAsDataURL(file);
  }

  function showCropDialog(event) {
    $mdDialog.show({
      controller: DialogController,
      targetEvent: event,
      template:
      '<md-dialog aria-label="Image cropper dialog" class="sb-ui-cropper-dialog">' +
      '  <md-dialog-content>'+
      '    <div layout="row" layout-align="center center" ng-show="!isDoneLoading">'+
      '      <md-progress-linear md-mode="indeterminate"></md-progress-linear>'+
      '    </div>'+
      ''+
      '    <ui-cropper'+
      '      ng-show="isDoneLoading === true"'+
      '      on-load-done="isDoneLoading = true"'+
      '      image="myImage"'+
      '      area-type="rectangle"'+
      '      aspect-ratio="0.640449438"'+
      '      init-max-area="true"'+
      '      result-image-quality="0.5"'+
      '      chargement="loadingText"'+
      '      result-image-size="{w: 570, h: 890}"'+
      '      result-image="myCroppedImage" canvas-scalemode="true">'+
      '    </ui-cropper>'+
      '  </md-dialog-content>' +
      '  <md-dialog-actions' +
      '     ng-show="isDoneLoading === true">' +
      '    <md-button ng-click="cancel()">' +
      '      Cancelar' +
      '    </md-button>' +
      '    <md-button ng-click="cropImage(myCroppedImage)" class="md-accent">' +
      '      Feito' +
      '    </md-button>' +
      '  </md-dialog-actions>' +
      '</md-dialog>',
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose:true,
      fullscreen: false
    })
    .then(function(myCroppedImage) {
      $ctrl.myCroppedImage = myCroppedImage;
      $ctrl.myImage = '';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });
  }

  function DialogController($scope, $mdDialog, $filter) {
    "ngInject";
    $scope.loadingText = $filter('translate')('common-loading');
    $scope.myImage = $ctrl.myImage;
    $scope.myCroppedImage = $ctrl.myCroppedImage;

    $scope.hide = function() {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      angular.element(document.querySelector('#fileInput')).val(undefined);
      $mdDialog.cancel();
    };

    $scope.cropImage = function(myCroppedImage) {
      $mdDialog.hide(myCroppedImage);
    }
  }

  function loadDomainResources() {
    $ctrl.uiState = 'LOADING';
    
    let promises = [];

    promises.push(News.index({limit: 10000000000, order: 'updated_at DESC'}));

    return Promise.all(promises);
  }

  function loadResource(id){
    if (id) {
      $ctrl.uiState = 'LOADING';

      Campaign.show(id)
        .then(response => {
          if (response.news_item_id) {
            $ctrl.selectedNewsItem = _.find($ctrl.newsItems, {id: response.news_item_id});
          }
          $ctrl.campaign = response;
          $ctrl.campaign.start_date = new Date($ctrl.campaign.start_date)
          $ctrl.campaign.end_date = new Date($ctrl.campaign.end_date)
          $ctrl.uiState = 'COMPLETE';
        })
        .catch(err => {
          console.log('err:' ,  err);
          $ctrl.uiState = 'ERROR';
        });
    } else {
      $ctrl.uiState = 'COMPLETE';
      $scope.$apply();
    }
  }

  function simulateImageLoadProgress() {
    $ctrl.loadingImage = true;
    $timeout(function() {
      $ctrl.loadingImage = false;
    }, 1000);
  }
}

CampaignDetailController.$inject = ['$filter', '$mdDialog', '$scope', '$state', '$timeout', 'Campaign', 'News', 'Toast'];

export default CampaignDetailController;


// WEBPACK FOOTER //
// ./client/app/components/campaign/campaign-detail.controller.js